// Mockup Cover Images
import CpersDropProjectMockup from '../images/project_mockups/cpersDropProjectMockup.png'
import DioProjectMockup from '../images/project_mockups/dioProjectMockup.png';
import CantaloupeProjectMockup from '../images/project_mockups/cantaloupeProjectMockup.png';
import AuraProjectMockup from '../images/project_mockups/auraProjectMockup.png';
import SpeakEasyProjectMockup from '../images/project_mockups/speakEasyProjectMockup.png';
import EarshotProjectMockup from '../images/project_mockups/earshotProjectMockup.png';
import ZenithProjectMockup from '../images/project_mockups/zenithProjectMockup.png';
import OmarProjectMockup from '../images/project_mockups/omarProjectMockup.png';
import OutlawProjectMockup from '../images/project_mockups/outlawProjectMockup.png';
import BRBSProjectMockup from '../images/project_mockups/BRBSProjectMockup.png';

// Project Detail Images

// CPERS Drop
import CpersHome from '../images/project_details/cpers_drop/home.png'
import CpersAbout from '../images/project_details/cpers_drop/about.png'
import CpersDashboard from '../images/project_details/cpers_drop/dashboard.png'
import CpersInterestChart from '../images/project_details/cpers_drop/interestChart.png'

// Outlaw
import OutlawAbout from '../images/project_details/outlaw/about.png';
import OutlawReviews from '../images/project_details/outlaw/reviews.png';
import OutlawContact from '../images/project_details/outlaw/contact.png';

// Omar
import OmarAbout from '../images/project_details/omar/about.png';
import OmarDiscography from '../images/project_details/omar/discography.png';

// Dio
import DioHomeScreen from '../images/project_details/dio/home.png';
import DioVenueInfo from '../images/project_details/dio/venueInfo.png';
import DioMixedDrink from '../images/project_details/dio/mixedDrink.png';
import DioCheckout from '../images/project_details/dio/checkout.png';

// Cantaloupe
import CantaloupeMobileApp from '../images/project_details/cantaloupe/mobileApp.gif';
import CantaloupeChatScreen from '../images/project_details/cantaloupe/chat.png';

// Earshot
import EarshotChat from '../images/project_details/earshot/chat.gif';
import EarshotMap from '../images/project_details/earshot/map.gif';
import EarshotProfile from '../images/project_details/earshot/profile.gif';

// Aura
import AuraAdminPortal from '../images/project_details/aura/admin.png'
import AuraDashboard from '../images/project_details/aura/dashboard.png'

// Content block types
export type ContentBlock =
    | { type: 'image'; src: string; alt?: string; size?: 'small' | 'medium' | 'large' | 'full' }
    | { type: 'caption'; text: string }
    | { type: 'text'; content: string }
    | { type: 'header'; text: string }
    | { type: 'subheader'; text: string }
    | { type: 'primary-button'; text: string; link: string }
    | { type: 'secondary-button'; text: string; link: string }
    | { type: 'code'; language: string; code: string }
    | { type: 'testimonial'; text: string; position: string; name: string }

export interface Project {
    id: string;
    title: string;
    description: string;
    image: string;
    tags: string[];
    status: "In Progress" | "Live" | "Archived" | "Beta";
    link?: string;
    content?: ContentBlock[];
}

export const projects: Project[] = [
    {
        id: "cpers-drop-portal",
        title: "CPERS DROP Member Portal",
        description: "A member portal for Baton Rouge's DROP program, built on a legacy ASP.NET MVC4 / .NET Framework 4.7.2 stack. My first project at Velocity Squared, where I drove most of the frontend and UX work alongside two other engineers.",
        image: CpersDropProjectMockup,
        tags: ["ASP.NET MVC4", ".NET Framework", "Bootstrap 5", "Chart.js", "CSS"],
        status: "Live",
        link: "https://cpers.brla.gov/",
        content: [
            { 
                type: 'header', 
                text: 'Modernizing a Pension Fund Portal on Legacy Government Infrastructure' 
            },
            { 
                type: 'text', 
                content: 'This was my first project after joining Velocity Squared. The CPERS DROP Member Portal is where members of a public pension fund\'s DROP program log in to check their account, review interest rates, and manage their info. I worked on this for about two months, February through March 2026, alongside two other engineers who handled most of the backend and infra work while I drove the majority of the frontend and UX side.' 
            },
            { 
                type: 'subheader', 
                text: 'The Constraint' 
            },
            { 
                type: 'text', 
                content: 'This wasn\'t a greenfield project. The app runs on ASP.NET MVC4 with .NET Framework 4.7.2. Super old. Government-pension-system old. Nothing gets thrown out and rebuilt from scratch in that world... you work around what\'s there, upgrade it carefully, and don\'t break anything for the members who rely on it to check their retirement accounts. That constraint shaped basically everything I did on this project.' 
            },{ 
                type: 'header', 
                text: 'Visual and UX Overhaul First' 
            },
            { 
                type: 'text', 
                content: 'The first big push was a full responsive restyle across the home page, About Us, the account tabs, check stubs, taxes section, FAQ, resources, login, and the admin panel. I refactored the CSS so the styling would actually be maintainable going forward instead of a pile of overrides. This gave us a clear target for what the site should actually look like.' 
            },
            { 
                type: 'image', 
                src: CpersHome, 
                alt: 'CPERS DROP Member Portal home page' 
            },
            { 
                type: 'caption', 
                text: 'The redesigned home page.' 
            },
            { 
                type: 'image', 
                src: CpersDashboard, 
                alt: 'CPERS DROP Member Portal account page' 
            },
            { 
                type: 'caption', 
                text: 'The main account page.' 
            },
            { 
                type: 'image', 
                src: CpersAbout, 
                alt: 'CPERS DROP Member Portal About Us page' 
            },
            { 
                type: 'caption', 
                text: 'The About Us page.' 
            },
            { 
                type: 'header', 
                text: 'Bootstrap 2 -> 5, Upgrading 14 Years in One Week' 
            },
            { 
                type: 'text', 
                content: 'With the new design in place, the next step was making sure it could actually live on modern infrastructure. The site was still running on 2012-era Bootstrap 2.3.0 across the entire app. I worked on this alongside another developer on the team who\'d been through this kind of legacy refactor before and showed me the ropes, how to approach a migration like this without breaking a live production app, how to think about sequencing changes, what to watch for. He did a lot of the heavy lifting here, especially early on, and I learned a ton from working next to him on it.' 
            },
            { 
                type: 'text', 
                content: 'Together we migrated the whole thing to Bootstrap 5.3 while preserving the visual overhaul I\'d just finished, instead of doing the redesign and the framework migration as one tangled effort. It touched around 55 files: rebuilding the navbar and toggler from scratch, migrating every data-toggle and data-target attribute over to data-bs-*, rewriting the grid system, form markup, and alert components to match Bootstrap 5\'s conventions, and swapping out every Glyphicon for Font Awesome since Glyphicons don\'t exist anymore. We broke the migration into phases that could each be reverted on their own if something broke in production. After deploy, I ran into a CSS caching issue where existing logged-in users were still getting served the old stylesheet, so I tracked that down and fixed it myself.' 
            },
            { 
                type: 'subheader', 
                text: 'My Takeaway' 
            },
            { 
                type: 'text', 
                content: 'This was less about me carrying the hardest part solo and more about learning how to do legacy migrations the right way from someone who\'d done it before. Taking a finished redesign and migrating a decade-old CSS framework underneath it taught me a lot about risk management and protecting work that\'s already done. It\'s one of the pieces of this project I learned the most from.' 
            },
            {
                type: 'text',
                content: 'There\'s no "move fast and fix it later" when you\'re dealing with people\'s retirement accounts.'
            },
            { 
                type: 'header', 
                text: 'Interactive Data Visualization' 
            },
            { 
                type: 'text', 
                content: 'Before this, the historical DROP interest rate chart on the site was a static image. Someone would build it in Excel, drop it into Photoshop, export a PNG, and upload it every single time the rates needed updating. That process was extremely slow and tedious, so I replaced the whole thing with a live Chart.js chart that pulls from a data file. Now, updating the rates is just editing a file instead of redoing an insane export chain.' 
            },
            { 
                type: 'image', 
                src: CpersInterestChart, 
                alt: 'Interactive DROP interest rate history chart' 
            },
            { 
                type: 'caption', 
                text: 'The interactive interest rate history chart, replacing what used to be a static image.' 
            },
            { 
                type: 'header', 
                text: 'Admin Panel Work' 
            },
            { 
                type: 'text', 
                content: 'I also picked up a handful of admin-facing features: the ability to filter and print account history by year, pagination on the admin side, and making the homepage content dynamically editable by admins instead of hardcoded into the templates. I redid the admin dashboard to be responsive too, since it hadn\'t been touched in a while.' 
            },
            { 
                type: 'header', 
                text: 'Member-Facing Features' 
            },
            { 
                type: 'text', 
                content: 'On the member side, I built out the beneficiary display on the account page, which meant writing some of the backend query logic myself, not just the frontend. I also worked on improving the login and password-reset flow.' 
            },
            { 
                type: 'header', 
                text: 'How It Turned Out' 
            },
            { 
                type: 'text', 
                content: 'Between the framework migration, the visual overhaul, the chart rebuild, the admin features, and the member-facing work, I ended up touching most of the site. For a first project at a new job, it was a good way to get thrown into a real, load-bearing government system and come out the other side having modernized a meaningful chunk of it without breaking anything for the members using it.' 
            },
            { 
                type: 'primary-button', 
                text: 'Visit CPERS Drop', 
                link: 'https://cpers.brla.gov/' 
            },
        ]
    },
    {
        id: "outlaw-defense",
        title: "OutlawDefense.com",
        description: "A custom React-based website for a criminal defense law firm in Texas. The site features info about his past cases, prestigious awards, and client testimonials.",
        image: OutlawProjectMockup,
        tags: ["React", "Node.js", "Figma", "AWS Amplify", "Email.js"],
        status: "Live",
        link: "https://www.outlawdefense.com/",
        content: [
            { 
                type: 'header', 
                text: 'Building a Website for a Criminal Defense Attorney' 
            },
            { 
                type: 'text', 
                content: 'Joe Wells is a criminal defense attorney in Houston who\'d been practicing for years without a website. He got some quotes from other developers that were way out of his budget, so he reached out to see if I could help him out. He needed something online so people could actually find him on Google and learn about what he does.' 
            },
            { 
                type: 'subheader', 
                text: 'The Problem' 
            },
            { 
                type: 'text', 
                content: 'Joe had literally nothing online—no website, no logo, nothing. If someone searched for a criminal defense attorney in Houston, they\'d never find him. He needed a full brand identity and a legit website that could hold its own against the big established firms, but without spending a fortune.' 
            },
            { 
                type: 'header', 
                text: 'What I Did' 
            },
            { 
                type: 'text', 
                content: 'I handled the whole project solo and got it done in about a month. I designed the UX, built the site in React, worked with a designer friend to get the logo done, and deployed everything to AWS Amplify.' 
            },
            { 
                type: 'subheader', 
                text: 'The Branding Process' 
            },
            { 
                type: 'text', 
                content: 'The way we did the branding was pretty funny. Joe literally sketched something on a napkin, threw it into ChatGPT to clean it up a bit, and then I got a designer I know to turn it into something actually professional. It was a scrappy process but it worked and kept costs way down.' 
            },
            { 
                type: 'image', 
                src: OutlawProjectMockup, 
                alt: 'OutlawDefense.com branding' 
            },
            { 
                type: 'caption', 
                text: 'The final branding for OutlawDefense.com.' 
            },
            { 
                type: 'subheader', 
                text: 'What\'s on the Site' 
            },
            { 
                type: 'text', 
                content: 'I built out a few key sections: an About page so people can get to know Joe, a Past Cases section showing some wins, embedded videos to add a personal touch, client reviews for credibility, and a contact form using EmailJS so potential clients can reach out easily.' 
            },
            { 
                type: 'image', 
                src: OutlawAbout, 
                alt: 'OutlawDefense.com homepage' 
            },
            { 
                type: 'caption', 
                text: 'The about section.' 
            },
            { 
                type: 'image', 
                src: OutlawReviews, 
                alt: 'OutlawDefense.com reviews' 
            },
            { 
                type: 'caption', 
                text: 'Client reviews section.' 
            },
            { 
                type: 'subheader', 
                text: 'Tech Stack' 
            },
            { 
                type: 'text', 
                content: 'I built this in React mostly because I wanted to challenge myself and have something custom for my portfolio. Yeah, I could\'ve used Squarespace or something, but where\'s the fun in that? I focused on making sure the branding was solid and that the site was easy to navigate.' 
            },
            { 
                type: 'text', 
                content: 'Getting EmailJS working for the contact form was honestly one of my favorite parts. It finally clicked after I\'d been trying to figure it out for a while—now the site can send emails directly to Joe without needing to set up a whole backend. Keeps things simple and cheap to host.' 
            },
            { 
                type: 'code', 
                language: 'javascript', 
                code: `import emailjs from '@emailjs/browser';

const handleSubmit = (e) => {
    e.preventDefault();
    
    emailjs.sendForm(
        'service_id',
        'template_id',
        e.target,
        'public_key'
    )
    .then(() => {
        alert('Message sent successfully!');
    })
    .catch((error) => {
        console.error('Failed to send:', error);
    });
};`
            },
            { 
                type: 'caption', 
                text: 'Basic EmailJS integration—you get the idea.' 
            },
            { 
                type: 'image', 
                src: OutlawContact, 
                alt: 'OutlawDefense.com contact form' 
            },
            { 
                type: 'caption', 
                text: 'The contact form.' 
            },
            { 
                type: 'subheader', 
                text: 'Deployment' 
            },
            { 
                type: 'text', 
                content: 'I deployed everything on AWS Amplify, which I\'ve been using for a few years now. It handles hosting, SSL certificates, and connects to Git so I can push updates whenever Joe needs something changed.' 
            },
            { 
                type: 'header', 
                text: 'How It Turned Out' 
            },
            { 
                type: 'text', 
                content: 'The site\'s been live for a while now and Joe\'s been using it to connect with clients. He\'s happy with how it turned out, and now he actually has an online presence. Before this, he had zero web traffic—now he shows up in search results and clients can actually find him and see he\'s legit.' 
            },
            { 
                type: 'subheader', 
                text: 'What I Learned' 
            },
            { 
                type: 'text', 
                content: 'This project reminded me that not everyone has a huge budget for web dev. By keeping things simple, using tools like EmailJS, and working efficiently, I was able to build something custom that actually looks professional without the typical price tag. Going from zero to launch in a month showed me that you can move fast when you plan things out and stay focused.' 
            },
            {
                type: 'testimonial',
                text: "I had the pleasure of working with John on my website for my criminal defense practice. His ability to translate my requirements into a sleek website exceeded my expectations.",
                name: 'Joe Wells',
                position: 'Criminal Defense Attorney, Outlaw Defense LLC',
            },
            { 
                type: 'primary-button', 
                text: 'Visit OutlawDefense.com', 
                link: 'https://www.outlawdefense.com/' 
            },
        ]
    },
    {
        id: "baton-rouge-bubble-sorters",
        title: "Baton Rouge Bubble Sorters",
        description: "A data visualization project for my Fantasy Football team, the Baton Rouge Bubble Sorters. The platform features weekly performance charts, player stats, and cool insights.",
        image: BRBSProjectMockup,
        tags: ["Next.js", "Figma", "AWS Amplify", "Chart.js", "ESPN API"],
        status: "In Progress",
        link: "https://www.bubblesorters.com/"
    },
    {
        id: "cantaloupe",
        title: "Cantaloupe",
        description: "A mobile job application platform built with React Native, featuring a swipe-based interface for job seekers and an employer portal for tracking applicants.",
        image: CantaloupeProjectMockup, // You'll need to add your image import
        tags: ["React Native", "React", "AWS", "Stream Chat"],
        status: "Archived",
        content: [
            { 
                type: 'header', 
                text: 'Building a Job Matching App for a Local Startup' 
            },
            { 
                type: 'text', 
                content: 'Cantaloupe was a local startup that reached out to my company, Zenith Software, to build their MVP. They wanted to tackle the problem of high turnover in hourly jobs by creating better matches between employers and applicants. The idea was to use a Tinder-style interface where job seekers could swipe on positions, and employers could see their best matches ranked by compatibility.' 
            },
            { 
                type: 'image', 
                src: CantaloupeMobileApp, 
                alt: 'The mobile app interface showing job swiping and chatting',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'The Cantaloupe mobile app interface.' 
            },
            { 
                type: 'subheader', 
                text: 'The Problem' 
            },
            { 
                type: 'text', 
                content: 'The team at Cantaloupe noticed that a lot of hourly workers would get hired and then quit within weeks because the job wasn\'t actually a good fit. They wanted to build something that could help both sides find better matches upfront, reducing that initial turnover and saving everyone time and money.' 
            },
            { 
                type: 'header', 
                text: 'What We Built' 
            },
            { 
                type: 'text', 
                content: 'The project had two main parts: a mobile app for job seekers built in React Native, and a web-based employer portal where businesses could post jobs and manage their applicants. I worked on this with my coworkers Calvin and Tre over a few months. Our team was split between this and another project at the time, so we had to stay pretty focused.' 
            },
            { 
                type: 'subheader', 
                text: 'The Employer Portal' 
            },
            { 
                type: 'text', 
                content: 'The employer side was where things got interesting for me. Employers could see everyone who matched with their job posting, sorted by match percentage so they could prioritize the best candidates. We also built in messaging so they could communicate directly with applicants.' 
            },
            { 
                type: 'text', 
                content: 'The messaging feature was probably the trickiest part of the whole project. We wanted to use Stream Chat, but Stream doesn\'t play nice with React Native on the web. Our workaround was to iframe a pure React interface into the React Native app, which let us reuse the RN components we\'d already built. It was hacky but it worked, and honestly pretty clever once we figured it out.' 
            },
            { 
                type: 'image', 
                src: CantaloupeChatScreen, 
                alt: 'The Cantaloupe employer chatting interface',
                size: 'full'
            },
            { 
                type: 'caption', 
                text: 'The employer chat interface using an iframe workaround.' 
            },
            { 
                type: 'subheader', 
                text: 'Tech Stack' 
            },
            { 
                type: 'text', 
                content: 'We built the mobile app in React Native so it could run on both iOS and Android without maintaining separate codebases. The backend was all AWS, which handled all user data. For the chat functionality, we integrated Stream Chat through that iframe solution I mentioned.' 
            },
            { 
                type: 'code', 
                language: 'javascript', 
                code: `// React Native WebView wrapping the chat interface
import { WebView } from 'react-native-webview';

const ChatScreen = ({ userId, channelId }) => {
    const chatUrl = \`https://app.cantaloupe.com/chat?user=\${userId}&channel=\${channelId}\`;
    
    return (
        <WebView
            source={{ uri: chatUrl }}
            style={{ flex: 1 }}
            javaScriptEnabled={true}
        />
    );
};`
            },
            { 
                type: 'caption', 
                text: 'Loading the React chat interface inside React Native with a WebView.' 
            },
            { 
                type: 'header', 
                text: 'How It Turned Out' 
            },
            { 
                type: 'text', 
                content: 'Unfortunately, after a few months of solid development, they got some feedback that made them rethink their approach. They ended up pivoting to a different product and built the new version in-house, so what we made never actually launched. It happens sometimes with startups, especially early-stage ones.' 
            },
            { 
                type: 'subheader', 
                text: 'What I Learned' 
            },
            { 
                type: 'text', 
                content: 'This project was a great dive into React Native. I learned a ton about mobile development, cross-platform considerations, and how to architect an app that needs to work smoothly on multiple devices. The iframe hack for Stream Chat taught me that sometimes you have to get creative when the tools don\'t line up perfectly.' 
            },
            { 
                type: 'text', 
                content: 'Working with a startup also showed me how quickly goals and priorities can shift. You need to be just as agile as they are, which means staying flexible and not getting too attached to any single feature or approach. It\'s challenging, but that\'s part of what makes it interesting.' 
            },
            {
                type: 'testimonial',
                text: "John is a great communicator. I always felt like he communicated clearly when I worked with him, even when collaborating on a complicated project with many moving parts.",
                name: 'Joshua Anderson',
                position: 'Co-Founder / CTO, Cantaloupe AI'
            }
        ]
    },
    {
        id: "dio-mobile-app",
        title: "Dio Mobile App",
        description: "Order and pay for your favorite cocktails, beers, or wines before you arrive at the bar. Walk in, grab your drink, and enjoy your night without the wait.",
        image: DioProjectMockup,
        tags: ["React Native", "Expo", "Stripe", "DynamoDB", "Figma", "AWS", "Twilio"],
        status: "Beta",
        content: [
            { 
                type: 'header', 
                text: 'Building an App to Skip Bar Lines' 
            },
            { 
                type: 'text', 
                content: 'We\'ve all been there. You\'re out with friends, the music is great, the vibe is perfect, and then you spend 20 minutes waiting in line just to order a drink. In May 2024, a recent Tulane grad came to my team at Zenith Software with an idea to fix this. The concept: order your drinks ahead through an app, pay on your phone, and pick them up without waiting in line.' 
            },
            { 
                type: 'text', 
                content: 'What seemed like a simple idea turned into a year-long project building a platform with two sides: one for customers ordering drinks, and another for venue staff managing those orders in real-time. I spent most of my time on UI/UX design and frontend development, especially the home screen and venue pages that would make or break the whole experience.' 
            },
            { 
                type: 'image', 
                src: DioHomeScreen, 
                alt: 'Dio app home screen',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'The home screen showing nearby venues' 
            },
            { 
                type: 'subheader', 
                text: 'How It Works for Customers' 
            },
            { 
                type: 'text', 
                content: 'The app starts with a quick onboarding flow, then you create an account using phone verification through Twilio—no passwords needed, which makes sense for college students and people at bars. Once you\'re in, you can see which venues near you have Dio.' 
            },
            { 
                type: 'text', 
                content: 'From there it\'s pretty straightforward: browse the menu, build your own drink, or pick from their specialty options. Pay through the app. The venue gets the order instantly, makes your drink, and marks it complete. You get a QR code on your phone, walk up to the bar, scan it, and grab your drink. No line, no cash, no hassle.' 
            },
            { 
                type: 'image', 
                src: DioVenueInfo, 
                alt: 'Venue information screen',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'Venue page showing menu and current wait times' 
            },
            { 
                type: 'subheader', 
                text: 'The Venue Side' 
            },
            { 
                type: 'text', 
                content: 'Early on, we realized the app had to work for both sides. Bars needed a dashboard to see incoming orders, mark drinks as ready, or decline orders if they ran out of something. This made things more complicated but it was necessary for the product to actually work in real life.' 
            },
            { 
                type: 'image', 
                src: DioMixedDrink, 
                alt: 'Drink ordering interface',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'Custom drink builder with specialty options' 
            },
            { 
                type: 'header', 
                text: 'Technical Stuff' 
            },
            { 
                type: 'text', 
                content: 'We started building this with React Native since our team had experience with it and the plan was to launch on multiple platforms. About halfway through, the client decided to go iOS-only, which let us focus on polishing one platform instead of spreading ourselves thin.' 
            },
            { 
                type: 'text', 
                content: 'The two biggest technical challenges were getting Stripe payments to work smoothly in the app, and handling real-time orders. Orders needed to show up instantly on the venue dashboard, and status updates had to push to customer phones right away. Making everything feel instant took a lot of work coordinating frontend state and backend events.' 
            },
            { 
                type: 'image', 
                src: DioCheckout, 
                alt: 'Checkout screen with payment integration',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'Checkout with Stripe integration' 
            },
            { 
                type: 'subheader', 
                text: 'Design Approach' 
            },
            { 
                type: 'text', 
                content: 'What I\'m most proud of is how the UI came out. The app feels smooth and is actually enjoyable to use. In a dark, crowded bar, every interaction needs to be obvious and every button needs to be easy to hit. We spent a lot of time on spacing, contrast, and flow to make sure the app would work in actual bar conditions—not just in perfect testing scenarios.' 
            },
            { 
                type: 'header', 
                text: 'Where Things Stand' 
            },
            { 
                type: 'text', 
                content: 'Dio is in private beta right now while the client onboards bars. There aren\'t public users yet, but the infrastructure is built and ready to scale once venue partnerships are in place.' 
            },
            { 
                type: 'text', 
                content: 'The biggest thing I learned from this year-long project? Map out your infrastructure early. Spend more time than feels necessary at the start diagramming every system and how they connect. It feels slow at first, but it saves you from countless hours of refactoring later. When you\'re building something with this many moving parts, having clarity up front makes all the difference.' 
            },
            { 
                type: 'subheader', 
                text: 'Final Thoughts' 
            },
            { 
                type: 'text', 
                content: 'Working on Dio for a year taught me that good products aren\'t just about solving a problem, they\'re about solving it in a way that feels effortless. Everyone hates waiting in line at a bar, but building an app that actually improves that experience takes obsessive attention to design, performance, and user flow. I\'m proud of what we built and looking forward to seeing it launch publicly.' 
            },
        ]
    },
    {
        id: "earshot",
        title: "Earshot: Localized Chatting",
        description: "Earshot revolutionizes social interaction by allowing users to anonymously join location-based chatrooms across the country.",
        image: EarshotProjectMockup,
        tags: ["React Native", "Stream Chat", "Figma", "Twilio"],
        status: "Live",
        link: "https://apps.apple.com/us/app/earshot-proximity-chat/id6471038992",
        content: [
            { 
                type: 'header', 
                text: 'Building Our First App Store Launch' 
            },
            { 
                type: 'text', 
                content: 'Earshot was our first mobile app to actually make it onto the App Store. We built it at Zenith Software as part of our senior-level Software Systems Development class with Professor Nash at LSU. The concept was pretty cool: anonymous chatrooms that you could only join if you were physically close enough.' 
            },
            { 
                type: 'image', 
                src: EarshotChat, 
                alt: 'The Earshot chat screen',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'The chat screen showing active conversations.' 
            },
            { 
                type: 'subheader', 
                text: 'The Idea' 
            },
            { 
                type: 'text', 
                content: 'We wanted to build something for college-aged users who wanted to interact with their communities in more interesting ways. The geo-location angle meant conversations were tied to real places, whether that was a specific building on campus, a coffee shop, or an event. And the anonymity part let people be more genuine without worrying about their identity being attached to everything they said.' 
            },
            { 
                type: 'header', 
                text: 'How It Works' 
            },
            { 
                type: 'text', 
                content: 'The app has three main screens: a home feed, a map view, and a profile page. On the home screen, you can see all the chatrooms within about 2 miles of your location. If there aren\'t many nearby, the search radius expands so the app still feels lively even if you\'re somewhere rural. You can only actually join rooms where you\'re inside the radius, which we usually set to about 50 yards larger than whatever space we wanted to cover.' 
            },
            { 
                type: 'image', 
                src: EarshotMap, 
                alt: 'The map view showing chatroom locations',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'The map view lets you explore chatrooms across the country.' 
            },
            { 
                type: 'text', 
                content: 'The map view lets you scroll around and see chatrooms anywhere. For our MVP, we only covered New Orleans and Baton Rouge, but the infrastructure is there to expand pretty much anywhere in the US.' 
            },
            { 
                type: 'subheader', 
                text: 'Anonymous But Recognizable' 
            },
            { 
                type: 'text', 
                content: 'One of my favorite features was the profile system. We wanted people to be anonymous but still pseudo-identifiable so you could have actual conversations with the same person across multiple interactions. I built this from the ground up. Each user picks an emoji and a color combination, and that becomes their identity in the app.' 
            },
            { 
                type: 'image', 
                src: EarshotProfile, 
                alt: 'The profile customization screen',
                size: 'small'
            },
            { 
                type: 'caption', 
                text: 'Customizing your anonymous identity with emoji and color combos.' 
            },
            { 
                type: 'text', 
                content: 'The cool part is that once you claim a color combo for your emoji, that combo is locked and unique to you. Nobody else can use it. This created exclusivity for early adopters and gave us a potential monetization path if we ever wanted to offer premium personalization. Behind the scenes, each emoji has an array of available colors stored in our AWS backend, and once a color gets taken, we flag it so it\'s no longer available.' 
            },
            { 
                type: 'code', 
                language: 'javascript', 
                code: `// Checking and claiming a unique emoji-color combo
const claimColorCombo = async (emoji, color) => {
    const availableColors = await fetchAvailableColors(emoji);
    
    if (availableColors.includes(color)) {
        await flagColorAsUsed(emoji, color);
        return { success: true, combo: { emoji, color } };
    }
    
    return { success: false, message: 'Color combo already taken' };
};`
            },
            { 
                type: 'caption', 
                text: 'Ensuring emoji-color combos stay unique across all users.' 
            },
            { 
                type: 'header', 
                text: 'Building and Launching' 
            },
            { 
                type: 'text', 
                content: 'The core app took about 6 months to build for the MVP. We came back about a year later during a dry period of work and added the profile and map features, which took another 3 months or so.' 
            },
            { 
                type: 'text', 
                content: 'Getting it through App Store approval was honestly a nightmare. We probably submitted 10 to 15 times, and each rejection was some small thing with user agreements or privacy policies. But we got there eventually.' 
            },
            { 
                type: 'subheader', 
                text: 'Tech Stack' 
            },
            { 
                type: 'text', 
                content: 'React Native gave us cross-platform support without maintaining two separate codebases. AWS handled all our backend services and data storage. Stream Chat powered the real-time messaging, and Twilio took care of user authentication through SMS verification.' 
            },
            { 
                type: 'header', 
                text: 'Where It Stands Now' 
            },
            { 
                type: 'text', 
                content: 'Earshot, in its current form, has been live on the App Store since around April 2025. We never really expected it to blow up or anything. The goal was more about having a solid portfolio piece that showed what we could build. Every now and then someone hops on and sends a message in the global chat we added, but otherwise it\'s pretty quiet. We added that global chat specifically because the user base is small, so at least people can interact with someone even if there aren\'t active local chatrooms.' 
            },
            { 
                type: 'subheader', 
                text: 'What I Learned' 
            },
            { 
                type: 'text', 
                content: 'This was our first real mobile app that made it all the way to the App Store, so we learned a ton about the whole process. The App Store approval process taught us patience and attention to detail, especially around privacy and user data. Building the unique color combo system was a good exercise in thinking through edge cases and making sure the backend could handle that kind of state management at scale.' 
            },
            { 
                type: 'text', 
                content: 'Working with location services in React Native also had its quirks. Making sure the app felt responsive while constantly checking your position and updating available chatrooms took some optimization. And balancing the UX between showing nearby rooms and not overwhelming users when there were too many was an interesting design challenge.' 
            },
            {
                type: 'testimonial',
                text: 'John has a real knack for design and the user experience! His talent for turning a vision into reality truly helped take Earshot to the next level.',
                name: 'Blake Bollinger',
                position: 'Co-Founder / CTO, Zenith Software'
            },
            {
                type: 'primary-button',
                text: 'View on App Store',
                link: 'https://apps.apple.com/us/app/earshot-proximity-chat/id6471038992'
            }
        ]
    },
    {
        id: "omar-ramirez-music",
        title: "OmarRamirezMusic.com",
        description: "A custom Squarespace website for a local musician in New Orleans. The site features info about his academic work, performance history, and discography.",
        image: OmarProjectMockup,
        tags: ["Squarespace", "Search Engine Optimization"],
        status: "Live",
        link: "https://www.omarramirezmusic.com/",
        content: [
            { 
                type: 'header', 
                text: 'Building a Portfolio Site for a New Orleans Musician' 
            },
            { 
                type: 'text', 
                content: 'Omar Ramirez is a Puerto Rican composer and trumpet player based in New Orleans. He\'s got a solid background in both jazz performance and academic composition, and he\'s played at Jazz Fest and other big venues around the city. But despite all that, he didn\'t have a website. A former roommate connected us, and Omar needed a professional site to show off his compositions and recordings.' 
            },
            { 
                type: 'image', 
                src: OmarAbout, 
                alt: 'OmarRamirezMusic.com about section' 
            },
            { 
                type: 'caption', 
                text: 'The top of the about section' 
            },
            { 
                type: 'subheader', 
                text: 'Why Squarespace?' 
            },
            { 
                type: 'text', 
                content: 'For this one, I went with Squarespace instead of building something custom. Omar needed a straightforward portfolio without any complex features, and he already knew his way around the platform a bit. This made it perfect for handing off later. He could update and maintain the site himself. Sometimes the simpler option is just better.' 
            },
            { 
                type: 'header', 
                text: 'How It Came Together' 
            },
            { 
                type: 'text', 
                content: 'I started with a Squarespace template but most of the final design was my own work. The site needed to feel professional and academic but also capture the energy of a working jazz musician. Over about a month, Omar and I worked through an agile process where I\'d build sections, get his feedback, and refine things based on what he wanted.' 
            },
            { 
                type: 'subheader', 
                text: 'What\'s on the Site' 
            },
            { 
                type: 'text', 
                content: 'The site has three main sections: an About page with his background and credentials, a Music page showcasing his compositional works, and a Discography section with his recordings on streaming platforms. The music and discography pages have embedded audio players so people can listen to his stuff right on the site.' 
            },
            { 
                type: 'image', 
                src: OmarDiscography, 
                alt: 'OmarRamirezMusic.com discography section' 
            },
            { 
                type: 'caption', 
                text: 'The discography section with streaming links.' 
            },
            { 
                type: 'subheader', 
                text: 'SEO Work' 
            },
            { 
                type: 'text', 
                content: 'To make sure Omar\'s work could actually be found by colleagues, venues, and potential collaborators, I set up SEO within Squarespace. I wrote targeted meta descriptions, worked in relevant keywords for jazz performance and academic composition, and structured everything so search engines could index it properly.' 
            },
            { 
                type: 'header', 
                text: 'How It Turned Out' 
            },
            { 
                type: 'text', 
                content: 'Omar\'s been really happy with the site and uses it to share his portfolio with colleagues, venues, and academic institutions. It acts as a central hub for his professional presence—people can explore his compositions, listen to his recordings, and learn about his background all in one place. For someone who had zero web presence before, this gives him the credibility and accessibility he needs for professional opportunities.' 
            },
            { 
                type: 'subheader', 
                text: 'What I Learned' 
            },
            { 
                type: 'text', 
                content: 'This project reminded me that the right solution isn\'t always the most technical one. By using Squarespace and focusing on design and user experience, I built something that met Omar\'s needs perfectly while making sure he could manage it himself going forward. Working through feedback regularly kept everything aligned with his vision throughout the process.' 
            },
            { 
                type: 'primary-button', 
                text: 'Visit OmarRamirezMusic.com', 
                link: 'https://www.omarramirezmusic.com/' 
            },
        ]
    },
    {
        id: "aura-dashboard",
        title: "Aura Advertising Client Dashboard",
        description: "Aura is a desktop dashboard designed to provide real-time data analytics for cartop advertisements.",
        image: AuraProjectMockup,
        tags: ["React", "Node.js", "DynamoDB", "Figma", "AWS Amplify", "Bluetooth", "Chart.js"],
        status: "Live",
        link: "https://dashboard.auraadco.com/",
        content: [
            { 
                type: 'header', 
                text: 'Tracking Impressions for Cartop Advertising' 
            },
            { 
                type: 'text', 
                content: 'Aura was Zenith Software\'s first real client. We met them at the Ignition 2.0 Program with Nexus Louisiana at the LA Tech Park in fall 2022. They had just won first place and a $10,000 check for their cartop billboard concept, and they needed a way to prove their ad impressions to potential investors.' 
            },
            { 
                type: 'image', 
                src: AuraDashboard, 
                alt: 'The Aura analytics dashboard',
                size: 'full'
            },
            { 
                type: 'caption', 
                text: 'The main dashboard showing impression data and map views.' 
            },
            { 
                type: 'text', 
                content: 'The whole idea was pretty straightforward. Aura runs ads on top of cars, and those cars drive around the city. They needed a dashboard that could show advertisers where their ads were being seen and how many people were actually exposed to them. We built an MVP over about 6 months that could do exactly that.' 
            },
            { 
                type: 'subheader', 
                text: 'What We Built' 
            },
            { 
                type: 'text', 
                content: 'The dashboard had two main views. The first was a map that showed where your ad had been displayed throughout the city and at what times. The second was the analytics view with daily and all-time impression counts. We used Bluetooth pings to roughly estimate how many people were in the vicinity when an ad rolled through an area. It wasn\'t perfect, but it gave Aura something tangible to show investors.' 
            },
            { 
                type: 'image', 
                src: AuraAdminPortal, 
                alt: 'The Aura admin portal',
                size: 'full'
            },
            { 
                type: 'caption', 
                text: 'An early version of the admin interface.' 
            },
            { 
                type: 'header', 
                text: 'Design Process' 
            },
            { 
                type: 'text', 
                content: 'I designed the entire dashboard in Figma before we wrote a single line of code. The goal was to keep things clean and minimal but still fun. I spent a lot of time on the typography because I wanted the data to feel approachable without being overwhelming. The charts ended up looking really cool, even if I think the data visualization could have been more useful in hindsight.' 
            },
            { 
                type: 'text', 
                content: 'Once the designs were locked in, I led our team of five developers through the frontend implementation. We used React with Chakra UI for the component library and Chart.js for all the data visualizations. The backend team handled the Bluetooth tracking logic and stored everything in DynamoDB, which we then pulled into the dashboard.' 
            },
            { 
                type: 'code', 
                language: 'javascript', 
                code: `// Fetching and rendering impression data
const loadImpressionData = async (adId) => {
    const data = await fetchImpressions(adId);
    
    const chartData = {
        labels: data.map(d => d.date),
        datasets: [{
            label: 'Daily Impressions',
            data: data.map(d => d.count),
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
        }]
    };
    
    return chartData;
};`
            },
            { 
                type: 'caption', 
                text: 'Pulling impression data and formatting it for Chart.js.' 
            },
            { 
                type: 'subheader', 
                text: 'First Client Challenges' 
            },
            { 
                type: 'text', 
                content: 'This was our first client ever at Zenith, so we didn\'t have our internal workflows figured out yet. The biggest challenge wasn\'t technical, it was keeping momentum going and making sure everyone stayed aligned. We were learning how to work with client deadlines, manage expectations, and deliver something polished while also figuring out our own processes as a team.' 
            },
            { 
                type: 'text', 
                content: 'Getting the backend data to integrate smoothly with the frontend charts was probably the most satisfying part. There were definitely moments where things weren\'t clicking, but when it finally came together and we could see real impression data flowing through the dashboard, it felt good.' 
            },
            { 
                type: 'header', 
                text: 'Tech Stack' 
            },
            { 
                type: 'text', 
                content: 'React powered the entire frontend. Chakra UI gave us a solid component library to build from, and Chart.js handled all the data visualization. DynamoDB stored the impression data and Bluetooth ping results on the backend. The Bluetooth tracking itself was handled by my colleague Blake, while I focused entirely on the frontend components and design implementation.' 
            },
            { 
                type: 'subheader', 
                text: 'Where Things Stand' 
            },
            { 
                type: 'text', 
                content: 'The dashboard is technically still running, but it was really just an MVP for Aura to use in investor pitches. I don\'t think they ever got the traction they needed to take it further, but the bones are there. For us, it was a huge learning experience and proof that we could deliver a real product for a real client.' 
            },
            { 
                type: 'header', 
                text: 'What I Took Away' 
            },
            { 
                type: 'text', 
                content: 'This project taught me a lot about working with clients, managing deadlines, and the general scrappiness of the startup world. Sometimes things just need to get done, and you have to figure out how to make it happen even when the path isn\'t clear. I also learned a ton about software practices and internal workflows, mostly by not having them and realizing how much easier things are when you do.' 
            },
            { 
                type: 'text', 
                content: 'Looking back, I probably would have approached the data visualization differently. It looks cool, but I\'m not sure it was as useful as it could have been for the end user. That said, it was our first client project, and we shipped something we were proud of. That counts for a lot.' 
            },
            {
                type: 'testimonial',
                text: "Working with John was an experience nothing short of exceptional. From the design stages through deliverables, John not only executed the product vision, but took a keen interest in understanding the product itself, which made for a better UI and UX. John is artistic, technical, and most importantly, flexible. If you're considering working with John, do it!",
                name: "David Rollins",
                position: "CEO, Aura Ad Co.",
            },
            {
                type: 'primary-button',
                text: 'View Case Study',
                link: "https://dashboard.auraadco.com/",
            }
        ]
    },
    {
        id: "speak-easy",
        title: "Speak Easy Website",
        description: "A custom website for a local band in Baton Rouge, LA. The website features info about the band, upcoming shows, and their music.",
        image: SpeakEasyProjectMockup,
        tags: ["React", "Node.js", "Figma", "AWS Amplify", "Spotify API"],
        status: "Live",
        link: "https://www.speakeasybandbr.com/"
    },
    {
        id: "zenith-software",
        title: "Zenith Software Website",
        description: "My company's website, showcasing our services, projects, and team members. Created in 2021, the site shwocases the beginning of our journey.",
        image: ZenithProjectMockup,
        tags: ["HTML", "CSS", "Material Tailwind", "Project Management"],
        status: "Live",
        link: "https://www.zenithsoftware.dev/"
    },
];

// Helper function to get a project by ID
export const getProjectById = (id: string): Project | undefined => {
    return projects.find(project => project.id === id);
};